import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BurgerButton from '@/components-latest/primitives/BurgerButton'
import { ArrowLeft } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'
import { selectIsSidebarOpen } from '@/ducks/app/selectors/app.selectors'
import { setSideBarOpen } from '@/ducks/app/slices/app.slice'

import Styles from './Header.module.scss'

interface IHeaderProps {
  title: string
  children?: React.ReactNode
  onGoBack?: () => void
}

const Header: React.FC<IHeaderProps> = ({ title, children, onGoBack }) => {
  const dispatch = useDispatch()
  const isSidebarOpen = useSelector(selectIsSidebarOpen)
  const onBurgerButtonClick = () => {
    dispatch(setSideBarOpen(!isSidebarOpen))
  }

  return (
    <header className={Styles.header} data-testid="header">
      <div className={Styles.burger}>
        <BurgerButton
          isOpen={isSidebarOpen}
          theme="dark"
          onClick={onBurgerButtonClick}
          size="big"
        />
      </div>
      {onGoBack && (
        <ArrowLeft
          data-testid="header-arrow-left"
          className={Styles.goBack}
          onClick={onGoBack}
        />
      )}
      <div className={Styles.content}>
        <Text variant="nextTitle-1">{title}</Text>
        {children && <div className={Styles.ctas}>{children}</div>}
      </div>
    </header>
  )
}

export default Header
